"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

require("mapbox-gl/dist/mapbox-gl.css");

var prop_types_1 = __importDefault(require("prop-types"));

var react_1 = __importStar(require("react"));

var react_map_gl_1 = __importStar(require("react-map-gl"));

var constants_1 = require("../../../constants");

var FontAwesome_1 = __importDefault(require("../../Icon/FontAwesome"));

var Base_1 = __importDefault(require("../Base"));

var constants_2 = require("./constants");

var Pin_1 = __importDefault(require("./Pin"));

var SideBar_1 = __importDefault(require("./SideBar"));

require("./style.scss");
/**
 * Map Moment to integrate a `story` with _OpenStreetMaps_.
 */


var MapMoment = function MapMoment(props) {
  var data = props.data;

  var _a = (0, react_1.useState)(true),
      sidebar = _a[0],
      setSidebar = _a[1]; // TODO: Make default zoom shrink to fix bounds of points


  var _b = (0, react_1.useState)({
    latitude: 37.785164,
    longitude: -100,
    zoom: 1
  }),
      viewport = _b[0],
      setViewport = _b[1];

  var _c = (0, react_1.useState)(undefined),
      selectedLocationIndex = _c[0],
      setSelectedLocationIndex = _c[1];

  var _d = (0, react_1.useState)(undefined),
      selectedLocation = _d[0],
      setSelectedLocation = _d[1];

  var _e = (0, react_1.useState)(undefined),
      tooltip = _e[0],
      setTooltip = _e[1];

  var selectLocation = function selectLocation(index) {
    setSelectedLocationIndex(index);
    var location = data[index];
    if (!location) return;
    setSelectedLocation(location);
    var coordinates = location.coordinates,
        label = location.label;
    setTooltip(label);
    setViewport({
      latitude: coordinates.latitude,
      longitude: coordinates.longitude,
      transitionInterpolator: new react_map_gl_1.FlyToInterpolator({
        speed: 2
      }),
      transitionDuration: 'auto',
      zoom: 11
    });
  };

  var markerKey = function markerKey(index) {
    return "marker-" + index;
  };

  var markers = data.map(function (_a, index) {
    var coordinates = _a.coordinates,
        details = _a.details;
    return react_1.default.createElement(react_map_gl_1.Marker, {
      key: markerKey(index),
      latitude: coordinates.latitude,
      longitude: coordinates.longitude
    }, react_1.default.createElement(Pin_1.default, {
      size: 10 + (details && details.length * 20 || 0),
      onClick: function onClick() {
        return selectLocation(index);
      }
    }));
  });
  /* eslint-disable react/jsx-props-no-spreading */

  return react_1.default.createElement(Base_1.default, __assign({}, props), react_1.default.createElement(SideBar_1.default, {
    data: data,
    onSelect: selectLocation,
    open: sidebar,
    selectedIndex: selectedLocationIndex
  }, react_1.default.createElement("div", {
    className: "map-wrapper"
  }, react_1.default.createElement(react_map_gl_1.default, __assign({
    mapStyle: constants_2.mapStyle
  }, viewport, {
    height: "100%",
    width: "100%",
    onViewportChange: function onViewportChange(vp) {
      return setViewport(vp);
    }
  }), markers, tooltip && selectedLocation && react_1.default.createElement(react_map_gl_1.Popup, {
    anchor: "top",
    closeOnClick: false,
    latitude: selectedLocation.coordinates.latitude,
    longitude: selectedLocation.coordinates.longitude,
    onClose: function onClose() {
      return setTooltip(undefined);
    },
    tipSize: 5
  }, selectedLocation.label), react_1.default.createElement("div", {
    className: "fullscreen",
    style: constants_2.fullscreenControlStyle
  }, react_1.default.createElement(react_map_gl_1.FullscreenControl, null)), react_1.default.createElement("div", {
    style: constants_2.sideBarControlStyle
  }, react_1.default.createElement("div", {
    className: "mapboxgl-ctrl mapboxgl-ctrl-group"
  }, react_1.default.createElement("button", {
    className: "mapboxgl-ctrl-icon",
    onClick: function onClick() {
      return setSidebar(!sidebar);
    },
    type: "button",
    title: "Toggle Info Panel"
  }, react_1.default.createElement(FontAwesome_1.default, {
    name: "FaMapSigns"
  })))), react_1.default.createElement("div", {
    className: "nav",
    style: constants_2.navStyle
  }, react_1.default.createElement(react_map_gl_1.NavigationControl, null))))));
};

MapMoment.propTypes = {
  /** Determines the background and text color of the `Moment` header. */
  color: prop_types_1.default.shape({
    background: prop_types_1.default.string,
    text: prop_types_1.default.string
  }),

  /** Stories-API data context to configure the `MapMarker`s. */
  data: prop_types_1.default.arrayOf(prop_types_1.default.shape({
    coordinates: prop_types_1.default.shape({
      latitude: prop_types_1.default.number.isRequired,
      longitude: prop_types_1.default.number.isRequired,
      point: prop_types_1.default.arrayOf(prop_types_1.default.number.isRequired).isRequired
    }).isRequired,
    label: prop_types_1.default.string,
    details: prop_types_1.default.arrayOf(prop_types_1.default.object)
  })),

  /** Used to serialize the order of the `Moment`s in a `Story` */
  index: prop_types_1.default.number,

  /** Determines the `SideBarSection` text of the `Moment`. */
  label: prop_types_1.default.string,

  /** Paragraph text underneath the title in `Moment` header */
  subtitle: prop_types_1.default.string,

  /** Main heading element of the `Moment` */
  title: prop_types_1.default.node,

  /** The type of `Moment` */
  type: prop_types_1.default.string
};
MapMoment.defaultProps = __assign(__assign({}, constants_1.MOMENT_BASE_DEFAULT_PROPS), {
  data: [],
  layout: constants_1.MomentLayout.Map,
  type: constants_1.MomentType.Map
});
exports.default = MapMoment;